const ActionTypes = {
    PEN: "pen",
    MARKER: "marker"
}

export default ActionTypes;